import { UsersRound } from "lucide-react";

export const PackageSize = ({ packageInfo, scope }) => {
  if (!packageInfo.size) return null;
  const { usd, gbp, employees } = packageInfo.size;
  const prefix = `${scope}-${packageInfo.id}`;
  return (
    <span data-testid={`${prefix}-size-guidance`} className="block mt-4">
      <span className="grid grid-cols-2 gap-x-4 gap-y-3 text-sm leading-relaxed">
        <span><span className="block text-xs font-medium">Annual revenue · USD</span><strong data-testid={`${prefix}-revenue-usd`} className="block mt-1 text-base font-semibold">{usd}</strong></span>
        <span><span className="block text-xs font-medium">Annual revenue · GBP</span><strong data-testid={`${prefix}-revenue-gbp`} className="block mt-1 text-base font-semibold">{gbp}</strong></span>
        <span data-testid={`${prefix}-employees`} className="col-span-2 flex items-center gap-2"><UsersRound aria-hidden="true" className="h-4 w-4 shrink-0" /><span><strong className="font-semibold">{employees}</strong> employees</span></span>
      </span>
    </span>
  );
};